import WorkflowGroupConnected from './workflow_group';

export default WorkflowGroupConnected;
